import React, { useMemo, useState, useEffect } from 'react'
import PageLayout from '../../layout/page_layout'
import StudioListingFormWizard, { StudioListingContentInput } from '../../components/studio_listing_form_wizard'
import { useNavigate, useParams } from 'react-router-dom'
import Loading from '../../components/loading'
import { StudioService } from '../../apilibrary'
import { IStudioModelWithAvailability, UpdateStudioInput } from '../../apilibrary/types/studio'
import useCurrentUserId from '../../hooks/useCurrentUserId'
import { trackStudioUpdate } from '../../utils/analytics'

const EditStudioPage: React.FC = () => {
  const { studioId } = useParams() as { studioId: string }
  const [studio, setStudio] = useState<IStudioModelWithAvailability>()
  const currentUserId = useCurrentUserId()
  const navigate = useNavigate()

  useEffect(() => {
    const fetchStudio = async (): Promise<void> => {
      const response = await StudioService.getStudioById(studioId)
      if (response?.ownerId !== currentUserId) navigate(`/studio/${studioId}`)
      const availability = await StudioService.getStudioAvailabilities(studioId)
      setStudio({
        ...response,
        availability
      })
    }
    void fetchStudio()
  }, [currentUserId, navigate, studioId])

  const content = useMemo(() => {
    const handleUpdateStudio = async (input: StudioListingContentInput): Promise<void> => {
      console.log(input)
      const updateInput: UpdateStudioInput = {
        info: input.info,
        availability: input.availability
      }
      console.log(input)
      await StudioService.updateStudio(studioId, updateInput)
      await trackStudioUpdate(input.info.title, input.ownerUserId);
      navigate(`/studio/${studioId}`)
    }

    if (!studio) {
      return <Loading />
    }

    return (
      <StudioListingFormWizard
        formTitle={studio?.info.title ?? 'Edit Studio Listing'}
        formData={studio}
        saveButtonLabel='Save Changes'
        onClickSave={handleUpdateStudio}
      />
    )
  }, [navigate, studio, studioId])

  return (
    <PageLayout addGutter authOnly>
      {content}
    </PageLayout>
  )
}

export default EditStudioPage
